import {MultiError} from "./multi-error";
import {detectErrors} from "../http/common";
import {uniqWith, isEqual} from "lodash";

export class GqlError extends MultiError {
  networkError: Error;
  graphQLErrors: Error[];
  name = "GqlError";

  errors: Error[];

  constructor(json: any) {
    super(json.message || "An unexpected error occurred.");

    Object.setPrototypeOf(this, GqlError.prototype);

    this.networkError = json.networkError || undefined;
    this.graphQLErrors = [];

    if (json.graphQLErrors && Array.isArray(json.graphQLErrors)) {
      for (const error of json.graphQLErrors) {
        try {
          detectErrors({error}); // might throw

          if (error instanceof Error) this.graphQLErrors.push(error);
          else this.graphQLErrors.push(new Error((error || {})["message"] || "An unexpected error occurred."));
        } catch (caught) {
          this.graphQLErrors.push(caught);
        }
      }
    }

    this.errors = [...(this.graphQLErrors as Error[])];
    this.errors = uniqWith(this.errors, isEqual);

    if (this.networkError) this.errors.unshift(this.networkError as Error);
  }
}
